import { GanttProps } from '@aicon-dev/caas-gantt';
import { useTranslation } from 'react-i18next';

export const useGanttLocale = () => {
  const { t } = useTranslation('schedule');

  const locale: GanttProps['locale'] = {
    day: t('schedule:day'),
    week: t('schedule:week'),
    month: t('schedule:month'),
    year: t('scheudle:year'),
    year_format: t('schedule:year_format'),
    day_format: t('schedule:day_format'),
    process: t('schedule:process'),
    accumulated_personnel: t('schedule:accumulated_personnel'),
    progress: t('schedule:progress'),
    drawing: t('schedule:drawing'),
    timelapse: t('schedule:timelapse'),
    rfi: t('schedule:rfi'),
    report: t('schedule:report'),
    special_note: t('schedule:special_note'),
    milestone: t('schedule:milestone'),
    accumulated_personnel_unit: t('schedule:accumulated_personnel_unit'),
    version: t('schedule:version'),
    rfi_status_ready: t('schedule:rfi_status_ready'),
    rfi_status_open: t('schedule:rfi_status_open'),
    rfi_status_close: t('schedule:rfi_status_close'),
    rfi_status_hold: t('schedule:rfi_status_hold'),
    rfi_status_archive: t('schedule:rfi_status_archive'),
    rfi_direct_link: t('schedule:rfi_direct_link'),
    rfi_not_assigned: t('schedule:rfi_not_assigned'),
    report_work_date: t('schedule:report_work_date'),
    report_dayoff: t('schedule:report_dayoff'),
    report_worker_num: t('schedule:report_worker_num'),
    report_worker_num_unit: t('schedule:report_worker_num_unit'),
    report_special_note: t('schedule:report_special_note'),
    report_milestone: t('schedule:report_milestone'),
    report_detail: t('schedule:report_detail'),
    sequence: t('schedule:sequence'),
    process_group_name: t('schedule:process_group_name'),
    color: t('schedule:color'),
    active: t('schedule:active'),
    modify_done: t('schedule:modify_done'),
    done: t('schedule:done'),
    cancel: t('schedule:cancel'),
    modify_popup_title: t('schedule:modify_popup_title'),
    select_basis_process: t('schedule:select_basis_process'),
    process_name: t('schedule:process_name'),
    process_name_placeholder: t('schedule:process_name_placeholder'),
    period: t('schedule:period'),
    start_date: t('schedule:start_date'),
    end_date: t('schedule:end_date'),
    sub_process: t('schedule:sub_process'),
    detail_process: t('schedule:detail_process'),
    add_sub_process_title: t('schedule:add_sub_process_title'),
    add_sub_process: t('schedule:add_sub_process'),
    add_process: t('schedule:add_process'),
    add_done: t('schedule:add_done'),
    add_detail_process_title: t('schedule:add_detail_process_title'),
    add_detail_process: t('schedule:add_detail_process'),
    delete: t('schedule:delete'),
    detail_process_name: t('schedule:detail_process_name'),
    data_empty: t('schedule:data_empty'),
    is_modified: t('schedule:is_modified'),
    preview_file: t('schedule:preview_file'),
    error_please_select_basis_process: t('schedule:error_please_select_basis_process'),
    error_please_add_process: t('schedule:error_please_add_process'),
    warning_disabled_process_title: t('schedule:t'),
    warning_disabled_process_description: t('schedule:t'),
    error_please_add_detail_process: t('schedule:error_please_add_detail_process'),
    error_please_type_field: t('schedule:error_please_type_field'),
    error_please_type_process_group_name: t('schedule:error_please_type_process_group_name'),
    warning_delete_process_group_title: t('schedule:warning_delete_process_group_title'),
    warning_delete_process_group_description: t('schedule:t'),
    process_group_deleted_message: t('schedule:process_group_deleted_message'),
    warning_delete_process_title: t('schedule:warning_delete_process_title'),
    warning_delete_process_description: t('schedule:t'),
    process_deleted_message: t('schedule:process_deleted_message'),
    warning_delete_detail_process_title: t('schedule:warning_delete_detail_process_title'),
    warning_delete_detail_process_description: t('schedule:t'),
    detail_process_deleted_message: t('schedule:detail_process_deleted_message'),
    type_field_placeholder: t('schedule:type_field_placeholder'),
    error_can_not_modify_period_on_has_child: t('schedule:t'),
    please_type_period: t('schedule:please_type_period'),
    error_some_is_duplicated: t('schedule:error_some_is_duplicated'),
    total_worker_num_unit: t('schedule:total_worker_num_unit'),
    modify: t('schedule:modify'),
  };

  return { locale };
};
